<template>
  <div id="app" :class="appClassName">
    <div class="page-content-without-footer">
      <Navigator />
      <transition name='fade' mode='out-in'>
        <div v-if="maintenanceOn" class="page-content">
          <h2>{{ $t('general.maintenance.title')}}</h2>
          <div>{{ $t('general.maintenance.message')}}</div>
        </div>
        <template v-else>
          <div>
            <div v-if="isConfigPage" class="page-content">
              <h5 class="text-error">
                <TranslationDomElements :value="$t('menu.config.warning')" />
              </h5>
            </div>
            <router-view v-if="configLoaded" />
            <b-spinner v-else variant="success" label="Spinning"></b-spinner>
          </div>
        </template>
      </transition>
    </div>
    <Footer />
  </div>
</template>

<style>
  .page-content-without-footer {
    min-height: calc(100vh - 90px);
  }
</style>

<script>
import Navigator from '@/components/navigator/Navigator.vue'
import Footer from '@/components/footer/Footer.vue'
import TranslationDomElements from '@/components/common/translationdomelements/TranslationDomElements.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Navigator,
    Footer,
    TranslationDomElements
  },
  computed: {
    ...mapState(['configLoaded', 'maintenanceOn']),
    isConfigPage () {
      if (this.$route.meta.isConfigPage) {
        return true;
      }
      return false;
    },
    appClassName () {
      const val = this.$store.getters.getDataFromConfigWithFilter('environment', null, null);
      if (val && val != 'production') {
        return 'server-DEV';
      } else if (!val && process.env) {
        return 'server-' + process.env.VUE_APP_ENV_NAME;
      }
      return 'server-live';
    }
  },
  mounted () {
    window.setInterval(() => {
      this.$store.dispatch('reloadConfig');
    }, 60000);

    window.setInterval(() => {
      if (this.$session) {
        this.$store.dispatch('checkSession');
      }
    }, 30000);
  },
  created () {
    this.ApiRequest.setPublicParams(this.$session, this.$router, this.$store);
    this.BasicHelper.setParams(this);
    this.ZPFormatHelper.setParams(this);
    this.$store.dispatch('loadConfig');
    if (this.$session) {
      this.$store.dispatch('loadTranslations');
      this.$store.dispatch('checkSession');
      const localeCode = this.$session.get('locale');
      if (localeCode) {
        this.$root.$i18n.locale = localeCode;
      }
    }
  }
}
</script>

<style src="../public/css/main.scss" lang="scss" />
